// extracted by mini-css-extract-plugin
module.exports = {"l1g9j0yd":"l1g9j0yd","c1eablvz":"c1eablvz","time":"time","d1gyj95u":"d1gyj95u"};